var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
var Header = /** @class */ (function (_super) {
    __extends(Header, _super);
    function Header() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Header.prototype.render = function () {
        return (React.createElement("div", { className: "rj-popup-message__header" },
            React.createElement("div", { className: "rj-popup-message__header-content" },
                this.props.html && React.createElement("div", { className: "rj-popup-message__header-html", dangerouslySetInnerHTML: { __html: this.props.html } }),
                this.props.children)));
    };
    return Header;
}(React.Component));
export { Header };
//# sourceMappingURL=Header.js.map